import React, { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

/**
 * Global offline notification banner
 * Shows at the top of the screen when internet connection is lost
 */
const OfflineNotification: React.FC = () => {
  const isOnline = useOnlineStatus();
  const [showReconnected, setShowReconnected] = useState(false);
  const [hasBeenOffline, setHasBeenOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setHasBeenOffline(true);
    }

    if (isOnline && hasBeenOffline) {
      // Show "reconnected" message briefly
      setShowReconnected(true);
      const timer = setTimeout(() => {
        setShowReconnected(false);
        setHasBeenOffline(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, hasBeenOffline]);

  // Show reconnected message
  if (showReconnected) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-green-500 text-white px-4 py-3 shadow-lg animate-slideDown">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
          <Wifi size={20} className="flex-shrink-0" />
          <p className="text-sm font-medium">
            Back online! Your connection has been restored.
          </p>
        </div>
      </div>
    );
  }

  // Show offline message
  if (!isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-3 shadow-lg animate-slideDown">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
          <WifiOff size={20} className="flex-shrink-0 animate-pulse" />
          <p className="text-sm font-medium">
            No internet connection. Some features may not work properly.
          </p>
        </div>
      </div>
    );
  }

  return null;
};

export default OfflineNotification;
